import { TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";

type ProductSearchProps = {
  value: string;
  onChange: (value: string) => void;
};

export const ProductSearch = (props: ProductSearchProps) => (
  <TextInput
    size="md"
    placeholder="Rechercher un produit…"
    leftSection={<IconSearch size={16} />}
    value={props.value}
    onChange={event => props.onChange(event.currentTarget.value)}
  />
);
